// extracted by mini-css-extract-plugin
module.exports = {"menuText":"#363b52","menuTextActive":"#108ee9","subMenuTextActive":"#f4f4f5","menuBg":"#fff","menuHover":"#f9f9f9","subMenuBg":"#fff","subMenuHover":"#f9f9f9"};